import {useDispatch, useSelector} from "react-redux";
import {dialogs, hideBlockCollabDialog, extendedCollab, loading} from "../../../store/slice";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Button, TextField} from "@mui/material";
import {useState} from "react";
import {LocalSpinner} from "../../../../../../shared/components/Spinner";
import {BlockUser} from "../../../store/actions";

export const BlockUserDialog = () => {
    const dispatch = useDispatch();
    const {blockCollabDialog} = useSelector(dialogs);
    const collab = useSelector(extendedCollab);
    const {isLoadingBlockCollab} = useSelector(loading);
    const [reason, setReason] = useState<string>('');

    const handleClose = () => {
        dispatch(hideBlockCollabDialog());
        setReason('');
    };

    const handleBlockUser = () => {
        if(collab){
            dispatch(BlockUser({reason, id: collab.publicId}));
            setReason('');
        }
    }

    return(
        <Dialog open={blockCollabDialog.isOpen} onClose={handleClose}>
            <DialogTitle>Block user</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    To block user type the reason below
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Blocking Reason"
                    fullWidth
                    variant="standard"
                    value={reason}
                    onChange={(e) => {setReason(e.target.value as string)}}
                />
            </DialogContent>
            {isLoadingBlockCollab ?
                <LocalSpinner />
                :
                <DialogActions>
                    <Button onClick={handleClose} color={'warning'}>Cancel</Button>
                    <Button onClick={handleBlockUser} disabled={!collab || !reason.trim().length} color={'success'}>Block</Button>
                </DialogActions>
            }
        </Dialog>
    )
}